import ColorToken from "./color-token";

export default ColorToken;
